import React from 'react';

interface ErrorMessageProps {
  error?: string;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, className }) => {
  if (!error) return null;

  return (
    <div 
      className={`error-message ${className || ''}`} 
      style={{ 
        color: '#d4322a', 
        fontSize: '12px', 
        marginTop: '1px',
        fontFamily: 'Raleway'
      }}
    >
      {error}
    </div>
  );
}; 